import { useState, useEffect } from "react";
import { Box, Typography, TextField } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../RecoilStates";
import { UseManageComments } from "./UseManageComments";
import CustomPagination from "../../components/CustomPagination";

export default function CommentsManagementGrid(props) {
  const { commentsList } = UseManageComments();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [commentsRes, setCommentsRes] = useState();
  const [filt, setFilt] = useState([]);

  useEffect(() => {
    setProgress(true);
    commentsList(true, (comments) => {
      setCommentsRes(comments);
    });
  }, []);

  useEffect(() => {
    if (props.refesh) {
      setProgress(true);
      commentsList(true, (comments) => {
        props.setRefesh(false);
        setCommentsRes(comments);
      });
    }
  }, [props.refesh]);

  useEffect(() => {
    setFilt([
      {
        columnField: "operator",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const columns = [
    {
      field: "id",
      width: 90,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "operator",
      headerName: "اپراتور",
      width: 200,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.operator}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      width: 130,
      align: "center",
      headerName: "موبایل",
      headerAlign: "center",
    },
    {
      field: "newComments",
      width: 100,
      align: "center",
      headerName: "در انتظار",
      headerAlign: "center",
    },
    {
      field: "confirmComments",
      width: 100,
      align: "center",
      headerName: "تایید شده",
      headerAlign: "center",
    },
    {
      field: "responseComments",
      width: 130,
      align: "center",
      headerName: "پاسخ داده شده",
      headerAlign: "center",
    },

    {
      field: "denyComments",
      width: 100,
      align: "center",
      headerName: "رد شده",
      headerAlign: "center",
    },
    {
      field: "search",
      width: 270,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "42rem", mb: 3 }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={commentsRes ? commentsRes : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={commentsRes && commentsRes.length ? commentsRes.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            nofab: true,
            isLtr: true,
            rowCount:
              commentsRes && commentsRes.length ? commentsRes.length : "",
          },
        }}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "&  .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "&  .MuiDataGrid-cell:focus-within ": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .MuiDataGrid-cell:hover": {
            opacity: "80%",
            cursor: "pointer",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !important",
          },
          "& .red": {
            backgroundColor: "#ff9c9c !important",
          },
          "& .red:hover": {
            backgroundColor: "#ffd5d5d1 !important",
          },
        }}
        getRowClassName={(params) => {
          if (params.row.newComments && params.row.newComments > 0) {
            return "red";
          }
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "newComments",
                sort: "desc",
              },
            ],
          },
        }}
      />
    </Box>
  );
}
